import { render } from "./EventAttendeesCardGroup.vue?vue&type=template&id=0c65c074&scoped=true"
import script from "./EventAttendeesCardGroup.vue?vue&type=script&lang=ts"
export * from "./EventAttendeesCardGroup.vue?vue&type=script&lang=ts"

import "./EventAttendeesCardGroup.vue?vue&type=style&index=0&id=0c65c074&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0c65c074"

export default script